import { matches, createSchemas } from '@sti/validation-schema';
import { useContexts } from '../useContext';

export const useContextCondition = ({ when, context, contextMap }) =>
  matches({ schemas: createSchemas(when) }, useContexts(context, contextMap));
